import Link from "next/link";

import { twMerge } from "@/utils/twMerge";

export const ListItem = ({
  size = "default",
  label,
  invertedHoverColor,
  content,
  rightController,
  href,
  onClick,
}: {
  size?: "default" | "sm" | "lg";
  label?: string;
  invertedHoverColor?: boolean;

  content: React.ReactNode;
  rightController?: React.ReactNode;

  href?: string;
  onClick?: () => void;
}) => {
  const contentWrapperClassName = twMerge(
    "flex flex-1 flex-row items-center w-full rounded-12 p-3 pl-2 pr-10 text-left",
    size === "sm" && "p-2",
    "hover:bg-sidebar-button-hover-bg group-hover:bg-sidebar-button-hover-bg",
    invertedHoverColor &&
      "hover:bg-blue-100 hover:dark:bg-blue-900 group-hover:bg-blue-100 group-hover:dark:bg-blue-900",
    "sm:flex-1 sm:hover:bg-transparent",
  );

  let contentWrapper = null;

  if (href) {
    contentWrapper = (
      <Link href={href} className={contentWrapperClassName}>
        {content}
      </Link>
    );
  } else if (onClick) {
    contentWrapper = (
      <button
        aria-label={label}
        onClick={onClick}
        type="button"
        className={contentWrapperClassName}
      >
        {content}
      </button>
    );
  } else {
    contentWrapper = <div className={contentWrapperClassName}>{content}</div>;
  }

  // TODO: make rightController not absolute, so it won't cover content and fit in mobile

  return (
    <div className="relative group flex flex-row flex-1 max-w-full">
      {contentWrapper}
      {rightController && (
        <div
          className={twMerge(
            "absolute top-[9px] right-[5px] flex",
            size === "sm" && "top-[7px]",
            "sm:top-[12px]",
          )}
        >
          {rightController}
        </div>
      )}
    </div>
  );
};
